import { render, staticRenderFns } from "./ActiveExpandPoolSimCards.vue?vue&type=template&id=2b142f5e&"
import script from "./ActiveExpandPoolSimCards.vue?vue&type=script&lang=js&"
export * from "./ActiveExpandPoolSimCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports